import { ProcesName } from '../../../containers/helpers/ProcesHandlerHelpers';
import { IFormConfig, ProcesHandler } from '../../../interfaces/FormConfig';
import { FormProps, FormState } from '../../../containers/FormContainer';

export class LidZoekenHelpers {
  static getProcesses(formConfig: IFormConfig): ProcesHandler[] {
      if (formConfig.procesHandlers !== 'lidzoeken') {
          return [];
      }
      return [
        {
            // PUT, before
            procesName: ProcesName.Put_preprocess,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                onError
            ) => {
                component.props.startLidZoeken();
                component.props.clearLidZoeken();

                // Specific Stakingsregistratie functionality
                if (component.props.formName == "MijnFNV_Stakingsregistratie_LidZoeken") {
                    const zoekenForm = component.props.forms["MijnFNV_Stakingsregistratie_LidZoeken"];
                    if (zoekenForm && zoekenForm.ZoekenOp === "qrcode") {
                        if (!zoekenForm["QRCode"]) {
                            return;
                        } 
                        data.ZoekenOp = "lidnummer";
                        data.Lidnummer = zoekenForm["QRCode"];
                    }
                }

                // When a 'load more' button exists, copy the payload from the `search`form to the load more form payload. This removes the need to make identical (redundant) forms.
                if (component.props.formName.includes("LaadMeer")) {
                  
                  const zoekenForm = LidZoekenHelpers.getPossibleSearchForms(component);
                  let property: keyof typeof zoekenForm; // Type is 'foo' | 'bar'

                  for (property in zoekenForm) {
                      data[`${property}`] = zoekenForm[property];
                  }
                }

                onSuccess(data);
            }
        },          
        {
            // PUT when done
            procesName: ProcesName.Put_postprocess_Success,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                onSuccess,
                onError
            ) => {
                const zoekenForm = LidZoekenHelpers.getPossibleSearchForms(component);

                const additionalData = {};    
                if (component.props.formConfig && component.props.formConfig.passthroughFieldsToGlobalState) {
                    component.props.formConfig.passthroughFieldsToGlobalState.map((passThroughFieldName) => {
                        if (zoekenForm[passThroughFieldName]) {
                            additionalData[passThroughFieldName] = zoekenForm[passThroughFieldName];
                        }
                    });
                }

                /*
                if (zoekenForm && zoekenForm.ZoekenOp === "qrcode") {
                    if (!zoekenForm["QRCode"]) {
                        return;
                    } 
                    zoekenForm.Lidnummer = zoekenForm["QRCode"];
                    zoekenForm.ZoekenOp = "lidnummer";
                }
                */

                if (zoekenForm && zoekenForm.Lidnummer && zoekenForm.Postcode) {
                    const lidnummer = zoekenForm.Lidnummer;
                    const postcode = zoekenForm.Postcode;
                    const huisnummer = zoekenForm.Huisnummer;
                    const geboortedatum = zoekenForm.Geboortedatum;
                    const zoekenOp = zoekenForm.ZoekenOp;
                                        
                    component.props.storeLidZoeken(data, lidnummer, postcode, huisnummer, geboortedatum, zoekenOp, "", component.props.formName, additionalData);
                    
                } else {
                    let zoekenOp = "";
                    if (zoekenForm.ZoekenOp && zoekenForm.ZoekenOp.value) {
                        zoekenOp = zoekenForm.ZoekenOp.value || "";
                    } else
                    if (zoekenForm.ZoekenOp) {
                        zoekenOp = zoekenForm.ZoekenOp || "";
                    }
                    component.props.storeLidZoeken(data, "", "", "", "", zoekenOp, zoekenOp !== "" && zoekenForm[zoekenOp], component.props.formName, additionalData);                    
                }
                onSuccess({
                    isPreventDefault: true
                });
                component.setState({
                    isSubmitting: false
                });                                                        
            }
        },          
        {
            // PUT when done
            procesName: ProcesName.Put_postprocess_Fail,
            execute: (
                component: React.Component<FormProps, FormState>,
                data: any,
                resolve,
                reject
            ) => {
                component.props.stopLidZoeken();
                component.props.clearLidZoeken();
                
                //when responseText is set, we can assume a custom error is preferred.
                if(data.responseText !== undefined && data.responseText !== ''){
                  resolve({isError: true, ErrorText: data.responseText});
                }
                else{
                  component.setState({
                    isShowPostDataError: true, 
                    isSubmitting: false 
                  });
                  resolve({});
                }                
                
            }
        }
      ];
  }
  
  private static getPossibleSearchForms(component: React.Component<FormProps, FormState>): any {
    const zoekenForm = component.props.forms["MijnFNV_LidZoeken"] ||
                    component.props.forms["MijnFNV_Stakingsregistratie_LidZoeken"] ||
                    component.props.forms["MijnFNV_LeadZoeken"] ||
                    component.props.forms["MijnFNV_PersoonZoeken"];
    return zoekenForm;
  }
}
